import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const counterRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('counters', {
      list: () => import(/* webpackChunkName: "admin" */ './Pages/List.vue'),
    })
      .except(['create', 'edit'])
      .permissions({
        list: 'counters.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
